<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CompanyService from "@/services/company";

export default {
  page: {
    title: "Layout",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      title: "Layout",
      settings: {
        layout: {}
      },
      loading: false
    };
  },
  methods: {
    load(showLoading = true) {
      let loader;
      if (showLoading) {
        loader = this.$loading.show();
      }

      CompanyService.getCompanyData().then(res => {
        this.settings = res.data.settings;

        if (loader) {
          loader.hide();
        }
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao carregar os dados');

        if (loader) {
          loader.hide();
        }
      })
    },
    save() {
      let loader = this.$loading.show();

      const data = {
        settings: {
          layout: this.settings.layout,
          use_cash_term_prices: !!this.settings.use_cash_term_prices,
        }
      }

      CompanyService.updateCompanyData(data).then(() => {
        this.$toast.open('Configurações atualizadas com sucesso');
        this.load(false);

        loader.hide();
      }).catch(() => {
        this.$toast.error('Ocorreu um erro ao atualizar os dados');
        loader.hide();
      })
    },
    addProductCarousel() {

    },
    removeProductCarousel() {

    },
    selectProductsCarousel() {
      if (this.settings.layout.show_products_carousel && this.settings.layout.products_carousel.length === 0) {
        this.settings.layout.products_carousel.push({})
      }
    }
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Home</h4>
            <p class="card-title-desc">Configurações da tela inicial do aplicativo</p>

            <form>
              <div class="row mt-4">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="custom-control custom-checkbox mb-0">
                      <input type="checkbox" class="custom-control-input" id="show_categories_carousel" v-model="settings.layout.show_categories_carousel" />
                      <label class="custom-control-label" for="show_categories_carousel">Mostrar carrossel de categorias</label>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="row mt-0">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="custom-control custom-checkbox mb-0">
                      <input type="checkbox" class="custom-control-input" id="show_products_carousel" @change="selectProductsCarousel"  v-model="settings.layout.show_products_carousel" />
                      <label class="custom-control-label" for="show_products_carousel">Mostrar carrossel de produtos</label>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="settings.layout.show_products_carousel">
                <div class="row" v-for="(productCarousel, index) in settings.layout.products_carousel" :key="index">
                  <div class="col-sm-4">
                    <div class="form-group">
                      <label :for="'variationSKU' + index">Título</label>
                      <input :id="'variationSKU' + index" type="text" class="form-control" v-model="productCarousel.title" />
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label :for="'variationDescription' + index">Exibir</label>
                      <select class="form-control" v-model="productCarousel.rules" :id="'variationDescription' + index">
                        <option>Ofertas</option>
                        <option>Lançamentos</option>
                        <option>Mais Vendidos</option>
                        <option>Aleatório</option>
                        <option>Por Categorias</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label :for="'variationPrice' + index">Limite</label>

                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span id="validationTooltipUsernamePrepend" class="input-group-text">R$</span>
                        </div>
                        <input
                          type="number"
                          id="'variationPrice' + index"
                          class="form-control"
                          v-model="productCarousel.limit"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-sm-1 mt-3 align-self-center">
                    <a class="action-icon text-danger" @click="removeProductCarousel(index)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-sm-10">
                    <div class="text-right">
                      <b-button pill variant="outline-primary" @click="addProductCarousel">+ Novo Carrossel</b-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Preços</h4>
            <p class="card-title-desc">Comportamento de exibição de preços no aplicativo</p>

            <form>
              <div class="row mt-4">
                <div class="col-sm-12">
                  <div class="form-group">
                    <div class="custom-control custom-checkbox mb-0">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="use_cash_term_prices"
                        v-model="settings.use_cash_term_prices"
                      />
                      <label class="custom-control-label" for="use_cash_term_prices">
                        Exibir preço à vista e a prazo
                      </label>
                    </div>
                    <small class="text-muted">
                      Quando ativado, os produtos com "Preço à vista" e "Preço a prazo" cadastrados
                      exibem o preço à vista em destaque com a informação do preço a prazo logo abaixo.
                    </small>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="text-sm-right">
      <button type="button" class="btn btn-primary btn-rounded" @click="save">Salvar Configurações</button>
    </div>
  </Layout>
</template>